import React, {useRef, useState, useEffect, forwardRef} from 'react'
import _ from './container.module.scss'
import {$, $$$} from '../shared/class-name'

export const Container = forwardRef(({
    background = false, border = true, padding = false, children, onClick, relative=true, columns=5,
    borderLight = false, backgroundLight = false, sideBorders = false, style={}, className, hiddenOverflow=false,
    childClassName, fill
}, ref) => {
    const childRef = useRef();
    const [fullWidth, setFullWidth] = useState(false)

    useEffect(() => {
        const el = childRef.current
        if (!el) return
        const check = () => setFullWidth(el.offsetWidth >= window.innerWidth)
        check()
        window.addEventListener('resize', check)
        return () => window.removeEventListener('resize', check)
    }, [])

    return <div className={$$$(_.root, $(className), $(_.background, background), $(_.backgroundLight, backgroundLight),
        $(_.border, border), $(_.borderLight, borderLight), $(_.hiddenOverflow, hiddenOverflow), $(_.fill, fill),
    )} style={style} onClick={onClick} ref={ref}>
        <div ref={childRef} className={$$$(_.child, $(childClassName), $(_.padding, padding), $(_.relative, relative), $(_[`_${columns}columns`]),
            $(_.sideBorders, sideBorders && !fullWidth))}>
            {children}
        </div>
    </div>
})
